import * as types from "./mutationTypes";

export default {
  async toggleJumpLogic({ commit, dispatch }, value) {
    if (!value) {
      await dispatch("resetSurveyJumpLogic");
    }
    commit(types.TOGGLE_JUMP_LOGIC, { value });
  },
  async resetSurveyJumpLogic({ state, dispatch }) {
    state.survey.items.map(async (i, index) => {
      if (i.jump_rules_enabled) {
        await dispatch("resetItemJumpLogic", index);
      }
    });
  },
  async resetItemJumpLogic({ commit, dispatch }, index) {
    await dispatch("toggleItemJumpLogic", { index, value: false });
    commit(types.RESET_ITEM_JUMP_LOGIC, { index });
  },
  toggleItemJumpLogic({ commit }, { index, value }) {
    commit(types.TOGGLE_ITEM_JUMP_LOGIC, { index, value });
  },
  selectAction({ commit }, { index, path, value }) {
    commit(types.SET_JUMP_LOGIC_ACTION, { index, path, value });
  },
  selectValue({ commit }, { index, path, value }) {
    commit(types.SET_JUMP_LOGIC_VALUE, { index, path, value });
  },
  selectOtherOptionAction({ commit }, { index, value }) {
    commit(types.SET_JUMP_LOGIC_OTHER_OPTION_ACTION, { index, value });
  },
  selectOtherOptionValue({ commit }, { index, value }) {
    commit(types.SET_JUMP_LOGIC_OTHER_OPTION_VALUE, { index, value });
  }
};
